export const EXSBITEMSCATEGORY_SHOW_RESET = 'EXSBITEMSCATEGORY_SHOW_RESET'
export const EXSBITEMSCATEGORY_SHOW_SET_ERROR = 'EXSBITEMSCATEGORY_SHOW_SET_ERROR'
export const EXSBITEMSCATEGORY_SHOW_SET_RETRIEVED = 'EXSBITEMSCATEGORY_SHOW_SET_RETRIEVED'
export const EXSBITEMSCATEGORY_SHOW_TOGGLE_LOADING = 'EXSBITEMSCATEGORY_SHOW_TOGGLE_LOADING'
